module.exports = "/_next/static/images/installationMaintenanceOfWaterSystems-ec8de2e4d22f9d6aaea2b96f9480de54.webp";